<template>
  <div>
    <!-- "Hub links" -->
    <CopytechHubLinks />

    <!-- Main navigation -->
    <NavBar />

    <!-- Router/Page content view -->
    <suspense>
      <router-view :key="$route.fullPath" />
    </suspense>

    <!-- Site Footer -->
    <SiteFooter />

    <!-- Modal component -->
    <transition name="fade">
      <Modal v-if="openModal" />
    </transition>

    <!-- Cookie consent -->
    <transition name="fade">
      <CookieConsent />
    </transition>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, onServerPrefetch } from 'vue'
import { useRoute } from 'vue-router'
import { logger } from '@repo/helpers/util/logger.js'

import CopytechHubLinks from './components/CopytechHubLinks.vue'
import NavBar from './components/NavBar.vue'
import SiteFooter from './components/SiteFooter.vue'
import Modal from './components/Modal.vue'
// import { getBrandModelId } from './helpers/product'
import CookieConsent from './components/CookieConsent.vue'

import { usePagesStore } from './store/modules/pages.js'
// import { useProductsStore } from './store/modules/products'
import { useBasketStore } from './store/modules/basket.ts'
import { useModal } from './composables/useModal.js'
// import { getUTMFromQuery } from './helpers/util/index.js'
import { storeUtmParamsOnce } from '@repo/helpers/util/utm'

const modal = useModal()
const route = useRoute()

const openModal = computed(() => modal.getModalStatus.value)

onServerPrefetch(async () => {
  try {
    if (route.meta.fetchPage) {
      await fetchPage()
    }
  } catch (error) {
    logger.error('Error in serverPrefetch:', error)
    throw { statusCode: 404, message: 'Page not found' }
  }
})
onMounted(() => {
  // Loads printer baskets from storage if it exists
  const basketStore = useBasketStore()
  basketStore.loadBasketFromStorage()

  // Store UTM parameters in a cookie
  // const query = route.query
  storeUtmParamsOnce()
  // const utm: {
  //   utm_source?: string
  //   utm_medium?: string
  //   utm_campaign?: string
  //   utm_term?: string
  //   utm_content?: string
  //   utm_capture_date?: string
  // } = getUTMFromQuery(query)

  // if (utm) {
  //   // Add utm_capture_date to the object
  //   utm.utm_capture_date = new Date().toISOString()
  //   // Store in local storage
  //   localStorage.setItem('utm_data', JSON.stringify(utm))
  // }

  // Remove preload form body
  document.body.classList.remove('preload')
})

async function fetchPage() {
  const store = usePagesStore()
  await store.fetchPage(route)
}
</script>
